import { render, staticRenderFns } from "./SingleAndMultiDashboardPage.vue?vue&type=template&id=57aac955&lang=pug&"
import script from "./SingleAndMultiDashboardPage.vue?vue&type=script&lang=ts&"
export * from "./SingleAndMultiDashboardPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports